import { render, staticRenderFns } from "./RegisteredKlientItem.vue?vue&type=template&id=536657d4&scoped=true&"
import script from "./RegisteredKlientItem.vue?vue&type=script&lang=js&"
export * from "./RegisteredKlientItem.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredKlientItem.vue?vue&type=style&index=0&id=536657d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536657d4",
  null
  
)

export default component.exports